import apiConfig from "constants/apiConfig";
import axiosClient from "utils/axiosClient";

export const fetchCollaborations = async (hubId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_COLLABORATIONS.url.replace('<hubId>', hubId), {params: payload});
    return response.data;
}

export const fetchCollaboration = async (hubId: string, campaignId: string, influencerId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_COLLABORATION.url.replace('<hubId>', hubId).replace('<campaignId>', campaignId).replace('<influencerId>', influencerId));
    return response.data.collaboration;
}